import {
  EncounterConditionDisplayModified,
  EncounterConditionDisplay
} from '../component/authenticated/types'
import { ObjectValues } from '../types/types'

const AssertionStatus = {
  Present: 'Present'
} as const

export type NLPPayload = {
  patientId: string
  documentId: string
  documentTypeCode: string
  documentDateOfService: string
  pageText: string
  targetId: string
  assertionStatus: ObjectValues<typeof AssertionStatus>
  hccCode: string
  hccDescription: string
  hccVersion: string
  icd10Code: string
  icd10Description: string
  predictedText: string | string[]
  predictedTextBegin: number
  predictedTextEnd: number
}

const nlpPayload: NLPPayload[] = [
  {
    patientId: 'aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee',
    documentId: 'aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee',
    documentTypeCode: 'OCR-Neurosurgery',
    documentDateOfService: '2022-07-07',
    pageText: `4/6/22, 10:43 AM Roller, David H (MR#E130731713) Printed by MERTZ, STACEY M [239149]

    NM MYOCARD PERF IMAG SPECT MULT
    [INM1082] (Accession NumberSA0222-
    73151M) (Order 814385788)

    Status: Final result (Resulted: 2/8/2022 11:57)

    Results

    >} Patient Information

    Patient Name Legal Sex DOB
    Roller, David H Male 4/30/1948

    Exam Information

    Exam Exam
    Status Begun Ended
    Final [99] 2/08/2022 08:21 2/08/2022 11:25

    ¬Æ Billing Indications

    Coronary artery disease involving native coronary artery of native heart without angina pectoris [l25.10 (ICD-10-
    CM)]
    Chest pain, unspecified type [RO7.9 (ICD-10-CM)]

    ‚ÄîE] Conclusion

    Lexiscan Myocardial Perfusion Imaging.
    DATE OF PROCEDURE: 322

    HISTORY/INDICATION:
    73 year-old male. Test performed due to chest pain.

    TECHNIQUE:

    SPECT imaging was obtained after 5.9 mCi of Technetium-99m Sestamibi
    was given during rest and 19.7 Technetiurn-99m Sestamibi was given
    during stress. During stress. the patient was given 0.4 mg of
    Lexiscan. Baseline heart rate is 63. Peak heart rate is 74. Baseline
    blood pressure is 180/99. Peak blood pressure is 160/86. Baseline EKG
    is sinus rhythm with no ischemic ST changes. Vasodilator EKG
    demonstrates no diagnostic ST changes for ischemia.

    Findings: The overall quality of the study is good. Rest and stress
    SPECT images demonstrate normal LV perfusion. Left ventricular cavity
    size is normal. The left ventricular ejection fraction is calculated
    to be 51%.

    Roller, David H (MRN E130731713) Printed by Mertz, Stacey M [239149] at 4/6/2022 10:43 AM

    https://epicmnkstl.mercy.net/EpicCareLink-PRDSTL/common/epic_main.asp 1/5
    `,
    targetId: 'aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee',
    assertionStatus: 'Present',
    hccCode: '1',
    hccDescription: 'HIV/AIDS',
    hccVersion: 'CMS_V24',
    icd10Code: 'B20',
    icd10Description: 'Human immunodeficiency virus [HIV] disease',
    predictedText: [ 'imaging', 'Baseline' ],
    predictedTextBegin: 598,
    predictedTextEnd: 605
  }
]

/**
 * Find the payloads that match the icd10 of the encounter condition.
 * 
 * @param payloads NLP payloads
 * @param ecd The encounter condition display we are concerned about
 * @returns A reduced array of NLP payloads that match the encounter condition
 */
export function filterPayloads(
  payloads: NLPPayload[],
  ecd: EncounterConditionDisplay | EncounterConditionDisplayModified
): NLPPayload[] {
  const payloadPredicate = (pyld: NLPPayload) => {
    if (!pyld.icd10Code || !(ecd.icd10CodeJson && ecd.icd10CodeJson.length > 0)) {
      // something is preventing us from comparing on the icd10 code, allow it by default
      return true
    }
    return pyld.icd10Code === ecd.icd10CodeJson[0]
  }
  return payloads.filter(payloadPredicate)
}

export default {
  nlpPayload,
  filterPayloads
}
